import { mockRankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            人气排行
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时热度排行，看看大家都在追哪些热门漫画
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {mockRankingItems.map((item, idx) => {
            const rankColors = [
              'bg-primary-500 text-background-50',
              'bg-accent-500 text-background-50',
              'bg-secondary-500 text-background-50',
            ];
            const rankClass = idx < 3 ? rankColors[idx] : 'bg-background-100 text-foreground-500';

            return (
              <div
                key={idx}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100/50 transition-colors ${
                  idx < mockRankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${rankClass}`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">{item.type}</span>
                    <span className="text-xs text-foreground-300">·</span>
                    <span className="text-xs text-foreground-400">{item.views}次阅读</span>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                    <i className={`text-xs ${
                      item.trend === 'up' ? 'ri-arrow-up-line text-accent-600' :
                      item.trend === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                      'ri-subtract-line text-foreground-400'
                    }`}></i>
                    {item.heat}
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-300"></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}